<template>
  <div class="save-state-container">
    <div class="save-state" :class="saveState" data-cy="save-state">
      <div class="save-state-content" v-show="saveState == 'unsaved'" data-cy="save-state-unsaved">
        <img class="save-state-content-icon" src="@assets/icons/SaveState/SaveUnchanged.svg" />
        {{ `${$t("saveState.unsaved")}` }}
      </div>
      <div class="save-state-content" v-show="saveState == 'saved'" data-cy="save-state-saved">
        <img class="save-state-content-icon" src="@assets/icons/SaveState/SaveSuccess.svg" />
        {{ `${$t("saveState.saved")}!` }}
      </div>
      <div class="save-state-content" v-show="saveState == 'saving'" data-cy="save-state-saving">
        <Spinner size="24" />
        {{ `${$t("saveState.saving")}...` }}
      </div>
      <b-btn variant="link" class="btn-with-icon save-state-content" v-show="saveState == 'error'" data-cy="save-state-error" @click="showErrorsModal">
        <img class="save-state-content-icon" src="@assets/icons/SaveState/SaveError.svg" />
        {{ `${$t("saveState.error")}` }}
      </b-btn>
    </div>
    <b-modal
      size="lg"
      body-class="save-state-errors-modal"
      :title="$t('saveState.errorsModalTitle')"
      v-model="isShownErrorsModal"
      header-close-content=""
      centered
      ok-only>
      <Icon icon="Error" size="32px" />
      <ul>
        <li v-for="error in errorList" :key="error?.toString()" class="error-entry">
          {{ error }}
        </li>
      </ul>
    </b-modal>
  </div>
</template>

<script setup lang="ts">
import { useSaveState } from "@common/composable/useRootStore";
import { ApiErrorData } from "@medapro-types/common/common";
import { AxiosError } from "axios";
import _ from "lodash";
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import Icon from "./Icon.vue";
import Spinner from "./Spinner.vue";

const { saveState, saveStateMeta } = useSaveState();
const { t: $t } = useI18n();

const isShownErrorsModal = ref(false);

const showErrorsModal = () => {
  isShownErrorsModal.value = true;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const isConflictError = (e: unknown): e is ApiErrorData => {
  return !!e && Object.hasOwn(e, "error") && Object.hasOwn(e, "value") && Object.hasOwn(e, "message");
};

const getErrorMessage = (error: unknown) => {
  if (!_.isString(error) && error instanceof Error) {
    if (error instanceof AxiosError) {
      const responsData: unknown = error.response?.data;
      if (error.status == 409 && isConflictError(responsData)) {
        return responsData.message ? responsData.message : $t(`error.${responsData.error}`, { prop: responsData.value });
      } else {
        return responsData;
      }
    } else {
      error.message;
    }
    return "";
  }
  return error;
};

const errorList = computed(() => {
  return _.chain(saveStateMeta.value.errors.map((x) => getErrorMessage(x)))
    .uniq()
    .compact()
    .value();
});
</script>
